<template>
    <div id="Container_ItemsReceivedListFilterRep">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="$t('ItemsReceivedListRep.ReportTitle')" />
            </b-col>
        </b-row>
        <b-row>
            <div class="col-sm-12 col-md-12 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="SearchItemsReceived"
                        />

                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="SearchItemsReceived"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </div>
        </b-row>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="DateFrom"
                    @input="DateFrom = $event"
                    :Id="'ItemsReceivedListFilterRepDateFrom'"
                    :Type="'date'"
                    :OnPressEnter="SearchItemsReceived"
                    :Change="DateFromChange"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="DateTo"
                    @input="DateTo = $event"
                    :Id="'ItemsReceivedListFilterRepDateTo'"
                    :Type="'date'"
                    :OnPressEnter="SearchItemsReceived"
                    :Change="DateToChange"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('ePharmacyItemsReceived.BatchNo')"
                    v-bind:Name="'Program'"
                    v-bind:TypeProp="'text'"
                    v-model="Batchno"
                    v-bind:Id="'input_dprogram_id'"
                    :OnPressEnter="SearchItemsReceived"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Options="pharmacyLocations"
                    v-bind:Model="locationModel"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="true"
                    :Input="ChangeLocation"
                    v-bind:Name="'note_types_select'"
                    id="note_types_select"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdLookupMultiSelect
                    v-bind:Label="$t('Shared.Item')"
                    v-bind:ModelCode="DrugsCodeModel"
                    v-bind:RefCode="'DrugsCode'"
                    v-bind:Api="'Drugs'"
                    v-bind:FieldCode="'drugCode'"
                    v-bind:FieldDescription="'drugname'"
                    :SearchTitle="$t('Medication.Drugs')"
                    :GetValues="getValuesDrugs"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'Code'"
                    :AuxFields="AuxFieldsDrugs"
                    :ServerSidePagination="true"
                    v-bind:Fields="BaseFieldsDrugs"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.InvoiceNumber')"
                    v-bind:Name="'invoiceNumber'"
                    v-model="InvoiceNumber"
                    v-bind:TypeProp="'text'"
                    v-bind:Id="'input_invoiceNumber'"
                    :OnPressEnter="SearchItemsReceived"
                    :Max="'30'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.PoNumber')"
                    v-bind:Name="'PurcharseNumber'"
                    v-model="PurcharseNumber"
                    v-bind:TypeProp="'text'"
                    v-bind:Id="'input_invoiceNumber'"
                    :OnPressEnter="SearchItemsReceived"
                    :Max="'30'"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdLookupMultiSelect
                    v-bind:Label="$t('Shared.Vendor')"
                    v-bind:ModelCode="VendorCodeModel"
                    v-bind:RefCode="'VendorCode'"
                    v-bind:Api="'Vendors?IsActive=true'"
                    v-bind:FieldCode="'vendorcode'"
                    v-bind:FieldDescription="'name'"
                    :SearchTitle="$t('Shared.Vendor')"
                    :GetValues="getValuesVendor"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'Code'"
                    :AuxFields="AuxFieldsVendor"
                    v-bind:Fields="BaseFieldsVendor"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <div class="mt-3 text-right">
                    <button
                        v-on:click="SearchItemsReceived"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>
        <div class="row">
            <div class="col-md-12">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            v-bind:refTable="refTable"
                            v-bind:IsItemsReceivedRep="true"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
        <div class="space-actions"></div>

        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="reportList"
                v-bind:Name="'btn_ReportList'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="onClickShowReport"
                v-bind:Name="'btn_Print'"
            />

            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$t('Shared.Export')"
                variant="primary"
                class="m-2"
            >
                <b-dropdown-item v-on:click="handlePdf('export')">{{
                    $t('Shared.PDF')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handlePdf('email')">{{
                    $t('Shared.PDFByEmail')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('export')">{{
                    $t('Shared.CSV')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('email')">{{
                    $t('Shared.CSVByEmail')
                }}</b-dropdown-item>
            </b-dropdown>
        </div>

        <DxPopup
            :visible="isReportVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('ItemsReceivedListRep.ReportTitle')"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
        >
            <ReportViewer
                ref="reportItemsReceivedListFilters"
                :ReportName="'ItemsReceivedList'"
                :ReportTitle="$t('ItemsReceivedListRep.ReportTitle')"
                :IsAnAPIReport="true"
            />
        </DxPopup>

        <CSVExportHelper
            ref="csvExportHelper"
            v-bind:conformSubject="$t('ItemsReceivedListRep.ReportTitle')"
            v-bind:sendEmailAPI="'/Utils/sendEmail'"
            v-bind:exportCsvAPI="'/ItemReceivedHeaders/exportCSV'"
        >
        </CSVExportHelper>
    </div>
</template>

<script>
import Vue from 'vue';
import DBFunctions from '@/common/DBFunctions.js';
import { DxPopup } from 'devextreme-vue/popup';
import ShowMessage from '@/components/messages/ShowMessage.js';
import ePharmacyLocationsService from '@/services/epharmacylocation.service';
import Utils from '@/common/utils';
import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js';
import UtilsService from '@/services/utils.service';
import { EventBus } from '@/event-bus.js';
import StorageService from '@/services/storage.service';

export default Vue.extend({
    name: 'ePharmacyItemsReceivedList',
    mixins: [DBFunctions, ShowMessage, PharmacyRepFunctions],
    components: { DxPopup },
    data() {
        return {
            fields: [
                {
                    key: 'TransactionNumber',
                    sortable: true,
                    label: this.$t('Shared.TransactionNo'),
                    class: 'text-right'
                },
                {
                    key: 'ReceivedDate',
                    sortable: true,
                    label: this.$t('Shared.ReceivedDate'),
                    class: 'text-center'
                },
                {
                    key: 'DrugName',
                    sortable: true,
                    label: this.$t('Shared.Item'),
                    class: 'text-Left'
                },
                {
                    key: 'QTYReceived',
                    sortable: true,
                    label: this.$t('Shared.QTYReceived'),
                    class: 'text-right'
                },
                {
                    key: 'UnitOfMeasure',
                    sortable: true,
                    label: this.$t('Shared.UOM'),
                    class: 'text-Left'
                },
                {
                    key: 'UnitPrice',
                    sortable: true,
                    label: this.$t('Shared.UnitPrice'),
                    class: 'text-right',
                    formatter: v => (v != null ? `$${Number(v).toFixed(2)}` : '')
                },
                {
                    key: 'TotalPrice',
                    sortable: true,
                    label: this.$t('Shared.TotalPrice'),
                    class: 'text-right',
                    formatter: v => (v != null ? `$${Number(v).toFixed(2)}` : '')
                },
                {
                    key: 'LotNo',
                    sortable: true,
                    label: this.$t('ItemAvailabilityRep.LotNo'),
                    class: 'text-Left'
                },
                {
                    key: 'Location',
                    sortable: true,
                    label: this.$tc('ePharmacyItemsReceived.Location'),
                    class: 'text-Left'
                },
                {
                    key: 'ExpirationDate',
                    sortable: true,
                    label: this.$tc('Shared.ExpirationDate'),
                    class: 'text-center'
                },
                {
                    key: 'InvoiceNumber',
                    sortable: true,
                    label: this.$t('Shared.InvoiceNumber'),
                    class: 'text-Left'
                },
                {
                    key: 'PoNumber',
                    sortable: true,
                    label: this.$t('Shared.PoNumber'),
                    class: 'text-Left'
                },
                {
                    key: 'Vendor',
                    sortable: true,
                    label: this.$t('Shared.Vendor'),
                    class: 'text-Left'
                },
                {
                    key: 'Comments',
                    sortable: true,
                    label: this.$t('Shared.Comments'),
                    class: 'text-Left'
                }
            ],
            FieldsDateArr: ['ReceivedDate', 'ExpirationDate'],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            DateFrom: null,
            DateTo: null,
            ShowMessageIsEmpty: '',
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0
            },

            params: {
                LocList: '',
                DrugList: '',
                VendorList: ''
            },
            DrugList: [],
            pharmacyLocations: [],
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            locationModel: null,
            isReportVisible: false,
            recNoToReport: null,
            DrugsCodeModel: [],
            VendorCodeModel: [],
            AuxFieldsVendor: ['address1', 'address2', 'zip', 'city', 'state', 'name'],
            BaseFieldsVendor: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name') },
                { key: 'vendorcode', sortable: true, label: this.$t('Shared.Code') },
                { key: 'address1', sortable: true, label: this.$t('Shared.Address1') },
                { key: 'city', sortable: true, label: this.$t('Shared.City') },
                { key: 'state', sortable: true, label: this.$t('Shared.State') }
            ],
            Batchno: '',
            InvoiceNumber: '',
            PurcharseNumber: '',
            refTable: 'selectableTable',
            AuxFieldsDrugs: ['status'],
            BaseFieldsDrugs: [
                { key: 'drugname', sortable: true, label: this.$t('Shared.DrugName') },
                { key: 'activeingred', sortable: true, label: this.$t('Shared.activeIngredients') },
                { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage') },
                { key: 'form', sortable: true, label: this.$t('Shared.Form') },
                { key: 'drugCode', sortable: true, label: this.$t('Shared.DrugCode') }
            ],
            isDateFromValid: true,
            isDateToValid: true
        };
    },

    methods: {
        getValuesDrugs: function(value) {
            this.DrugsCodeModel = value;
            this.params.DrugList = value.join(',');
        },

        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0];
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px';
        },

        onHiddenReport() {
            this.isReportVisible = false;
        },

        SearchItemsReceived() {
            if (!this.validateForm()) return;

            this.items = [];
            this.currentPage = 1;
            this.totalRows = this.items.length;
            this.parameter.PageNumber = 1;
            this.getListing();
        },

        getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_WebReceiveItems';
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                DateFrom: this.parameter.DateFrom,
                DateTo: this.parameter.DateTo,
                LocationCodeList: this.parameter.Locations,
                DrugCodeList: this.parameter.DrugList,
                BatchNoList: this.parameter.Batchno,
                InvoiceNumber: this.parameter.InvoiceNumber,
                PurcharseNumber: this.parameter.PurcharseNumber,
                VendorCodeList: this.parameter.VendorList,
                UserId: this.parameter.UserId
            };

            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };

            UtilsService.getExecuteSP(request)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;

                        this.items.forEach(function(element) {
                            let { ReceivedDate } = element;
                            if (ReceivedDate)
                                element.ReceivedDate = Utils.formatterDateToString(ReceivedDate);
                        });
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onClickClose() {
            this.isParamVisible = false;
        },

        reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: 'reportListPharmacy' }).catch(() => {});
        },

        initializeParameters() {
            // Asignaciones condicionales
            this.parameter.DrugList =
                this.params.DrugList && this.params.DrugList !== '' ? this.params.DrugList : null;

            this.parameter.DateFrom = this.DateFrom && this.DateFrom !== '' ? this.DateFrom : null;
            this.parameter.DateTo = this.DateTo && this.DateTo !== '' ? this.DateTo : null;
            this.parameter.PurcharseNumber =
                this.PurcharseNumber && this.PurcharseNumber !== '' ? this.PurcharseNumber : '';
            this.parameter.Batchno = this.Batchno && this.Batchno !== '' ? this.Batchno : '';
            this.parameter.VendorList =
                this.params.VendorList && this.params.VendorList !== ''
                    ? this.params.VendorList
                    : '';
            this.parameter.Locations =
                this.params.LocList && this.params.LocList !== '' ? this.params.LocList : null;
            this.parameter.InvoiceNumber =
                this.InvoiceNumber && this.InvoiceNumber !== '' ? this.InvoiceNumber : '';
            this.parameter.UserId = StorageService.getUserId();
        },

        initializePdfParameters() {
            this.reportParams = [];
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.DateFrom });
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.DateTo });
            this.reportParams.push({ paramName: 'pLocations', paramValue: this.params.LocList });
            this.reportParams.push({ paramName: 'pDrugList', paramValue: this.params.DrugList });
            this.reportParams.push({
                paramName: 'pVendorCodeList',
                paramValue: this.params.VendorList
            });
            this.reportParams.push({ paramName: 'pBatchNoList', paramValue: this.Batchno });
            this.reportParams.push({ paramName: 'pInvoiceNumber', paramValue: this.InvoiceNumber });
            this.reportParams.push({
                paramName: 'pPurcharseNumber',
                paramValue: this.PurcharseNumber
            });
            this.reportParams.push({
                paramName: 'pSearchCriteria',
                paramValue: this.parameter.SearchCriteria
            });
            this.reportParams.push({
                paramName: 'isUAE',
                paramValue: this.$store.state.companies.isUAE
            });
        },

        onClickShowReport() {
            this.isParamVisible = false;
            this.initializePdfParameters();
            this.isReportVisible = true;
            this.$refs.reportItemsReceivedListFilters.buildDocument(this.reportParams);
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getListing();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getListing();
        },

        DateFromChange() {
            this.parameter.DateFrom = this.DateFrom;
        },

        DateToChange() {
            this.parameter.DateTo = this.DateTo;
        },

        getPharmacyLocations() {
            const parameter = {
                PageSize: 0,
                PageNumber: 0,
                FilterByEmployee: true
            };

            this.pharmacyLocations = [];
            ePharmacyLocationsService
                .getAll(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.pharmacyLocations = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        ChangeLocation(value) {
            this.locationModel = value;
            this.params.LocList = value ? value.map(item => item.code).join(',') : '';
        },

        getValuesVendor(value) {
            this.VendorCodeModel = value;
            this.params.VendorList = value.join(',');
        },

        handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            switch (action) {
                case 'export':
                    this.$refs.csvExportHelper.exportCSV(this.parameter);
                    break;
                case 'email':
                    this.$refs.csvExportHelper.emailCSV(this.parameter);
                    break;
                default:
                    console.warn('unknow action:', action);
                    break;
            }
        },

        handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            switch (action) {
                case 'export':
                    this.$refs.csvExportHelper.exportToPdf(
                        'ItemsReceivedList',
                        true,
                        false,
                        this.reportParams
                    );
                    break;
                case 'email':
                    this.$refs.csvExportHelper.emailPdf(
                        'ItemsReceivedList',
                        true,
                        false,
                        this.reportParams
                    );
                    break;
                default:
                    console.warn('unknow action:', action);
                    break;
            }
        },

        validate_date_range() {
            return Utils.isDateFromAndDateTo(this.DateFrom, this.DateTo);
        },

        // Método de validación reutilizable
        validateForm() {
            const isValid = this.validate_date_range();

            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;

            // Forzar actualización del componente
            this.$forceUpdate();

            if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), 'error');
                return false;
            }
            return true;
        }
    },

    async created() {},

    async mounted() {
        this.getPharmacyLocations();
        EventBus.$on(
            'ShowWeel',
            function(isShow) {
                isShow ? this.$emit('load', true) : this.$emit('load', false);
            }.bind(this)
        );
    }
});
</script>
